// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#variation-image {
  background: white;
}
#variation-image img {
  width: 90%;
}

.custom-select {
  width: 100%;
  text-align: center;
}

ion-button.boxx-btn {
  min-height: 47px;
  margin: 10px 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/store/components/products/variant-creator/variant-creator.page.scss"],"names":[],"mappings":"AACA;EACI,iBAAA;AAAJ;AAEI;EACI,UAAA;AAAR;;AAIA;EACI,WAAA;EACA,kBAAA;AADJ;;AAIA;EACI,gBAAA;EACA,gBAAA;AADJ","sourcesContent":["\n#variation-image{\n    background: white;\n    \n    img{\n        width: 90%;\n    }\n}\n\n.custom-select{\n    width: 100%;\n    text-align: center;\n}\n\nion-button.boxx-btn {\n    min-height: 47px;\n    margin: 10px 0px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
